import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authReducer from "./auth/authSlice";
import homeReducer from "./home";
import blogReducer from './blog';
import aboutReducer from './about';
import roomReducer from './Room';
import galleryReducer from './Gallery';
import dinningReducer from './Dinning';
import eventReducer from './Event';
import aminityReducer from './Aminity';
import careerReducer from './Career';
import faqReducer from './Faq';
import contactUsReducer from './ContactUs';
import menuAccessReducer from './MenuAceess';
import footerReducer from './Footer';
import multiLanguageReducer from './multiLanguage';






const rootReducer = combineReducers({
    auth: authReducer,
    home: homeReducer,
    blog: blogReducer,
    about: aboutReducer,
    room: roomReducer,
    gallery: galleryReducer,
    dinning: dinningReducer,
    event: eventReducer,
    aminity: aminityReducer,
    career: careerReducer,
    faq: faqReducer,
    contactUs: contactUsReducer,
    menuAccess: menuAccessReducer,
    footer:footerReducer,
    multiLanguage:multiLanguageReducer


    
});

export const store = configureStore({
    reducer: rootReducer,
})

// Infer the RootState type from the store
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;